import React, { Fragment, useState } from 'react';
import {Link, useLocation} from 'react-router-dom';
import DesktopMenu from 'components/DesktopMenu';
import MobileTabMenu from 'components/MobileTabMenu';
// import logo from 'img/newsfetch-io.png';
import logo from 'img/ozmosys-logo2.png';
import betaSign from 'img/beta sign.png'
import { connect } from 'react-redux';
//import { Button } from 'reactstrap';

const Header = ({auth}) => {
    const location = useLocation();

    const [isOpen, toggleMenu] = useState(false);


    // if(location.pathname === '/status') return null;
    return (
        <Fragment>
            <header>
                <div className="wrapper d-flex justify-content-between align-items-center">
                    <Link to={auth.isAuthenticated ? '/organizations' : '/'} className="d-flex align-items-center ml-3">
                        {/*<div><img width="150px" src={logo} alt="logoImg" /></div>*/}
                        <div><img height="47px" src={logo} alt="logoImg" /></div>
                        {/*<div style={{ marginLeft: '3px', alignSelf: 'flex-start' }}><img width="35px" src={betaSign} alt="betaSign" /></div>*/}
                    </Link>
                    {/*window.innerWidth > 1023 &&
                        <div>
                            <img height="15px" src={logoText} alt="newsfetch logo" />
                        </div>
                    */}
                    <DesktopMenu />
                    <i
                        onClick={() => toggleMenu(!isOpen)}
                        style={{
                            fontSize: '20px',
                            width: '22px',
                            color: '#0f1c52',
                            cursor: 'pointer',
                        }}
                        className={`userMenuMobAndTab fas ${isOpen ? 'fa-times' : 'fa-bars'} mr-3`}
                    />
                    {isOpen && <MobileTabMenu isOpen={isOpen} toggler={toggleMenu} />}
                </div>
            </header>
        </Fragment>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    null
)(Header);
